// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconAdjustmentsHorizontal, IconFileAnalytics, IconFileStack, IconUsers, IconLocation, IconApple, IconPuzzle } from '@tabler/icons';

// type
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const icons = {
    IconAdjustmentsHorizontal,
    IconFileAnalytics,
    IconFileStack,
    IconUsers,
    IconLocation,
    IconApple,
    IconPuzzle,
};

const organization: NavItemType = {
  id: 'organizationSection',
  title: <FormattedMessage id="Organization" />,
  type: 'group',
  children: [
    {
            id: 'programs',
            title: <FormattedMessage id="Programs" />,
            icon: icons.IconFileStack,
            type: 'item',
            url: '/programs',
            target: false
    },
    {
        id: 'organization',
        title: <FormattedMessage id="Organization Settings" />,
        type: 'item',
        icon: icons.IconAdjustmentsHorizontal,
        url: '/organization',
        target: false
    },
    {
        id: 'administrators',
        title: <FormattedMessage id="Administrators" />,
        type: 'item',
        icon: icons.IconUsers,
        url: '/administrators',
        target: false
    },
    {
        id: 'regions',
        title: <FormattedMessage id="Regions" />,
        type: 'item',
        icon: icons.IconLocation,
        url: '/regions',
        target: false
    },
    {
        id: 'food-products',
        title: <FormattedMessage id="Food Products" />,
        type: 'item',
        icon: icons.IconApple,
        url: '/food-products',
        target: false
    },
    {
        id: 'integrationsSection',
        title: <FormattedMessage id="Integrations" />,
        type: 'collapse',
        icon: icons.IconPuzzle,
        children: [
            {
                id: 'lgl-integration',
                title: <FormattedMessage id="Little Green Light" />,
                type: 'item',
                url: '/lgl-integration',
                target: false
            },
            {
                id: 'sharing-excess-integration',
                title: <FormattedMessage id="Sharing Excess" />,
                type: 'item',
                url: '/sharing-excess-integration',
                target: false
            },
        ]
    },
  ]
};

export default organization;
